import React from "react";
import { FaGithub, FaLinkedin, FaCode, FaEnvelope } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-black text-white py-6 border-t border-gray-800">
      <div className="container mx-auto px-6">
        {/* Top Section */}
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start mb-6">
          {/* Social Icons */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <div className="flex space-x-6 mb-4">
              <a href="https://github.com/AMISHA2004-devgeek" target="_blank" rel="noopener noreferrer">
                <FaGithub className="w-8 h-8 text-gray-400 hover:text-orange-500" />
              </a>
              <a href="https://www.linkedin.com/in/amisha-kumari-351ab9274/" target="_blank" rel="noopener noreferrer">
                <FaLinkedin className="w-8 h-8 text-gray-400 hover:text-orange-500" />
              </a>
              <a href="mailto:amishakumarijsr009@gmail.com">
                <FaEnvelope className="w-8 h-8 text-gray-400 hover:text-orange-500" />
              </a>
              <a href="https://codolio.com/profile/Amisha_11">
                <FaCode className="w-8 h-8 text-gray-400 hover:text-orange-500" />
              </a>
            </div>
            <p className="text-sm text-gray-400">© 2025 AMISHA KUMARI. All rights reserved.</p>
          </div>

          {/* More Section */}
          <div className="mt-6 md:mt-0 flex flex-col items-center text-center">
  <h3 className="text-xl font-semibold text-orange-500 mb-2">More</h3>
  <nav className="flex flex-col items-center space-y-1">
    <a href="#events" className="text-white no-underline text-lg">Events & Hackathons</a>
    <a href="#positionrespons" className="text-white no-underline text-lg">Position of Responsibility</a>
    <a href="#recommend" className="text-white no-underline text-lg">Recommendations</a>
  </nav>
</div>

        </div>

        {/* Quick Links */}
        <div className="text-center border-t border-gray-700 pt-4">
          <h3 className="text-xl font-semibold text-orange-500 mb-2">Quick Links</h3>
          <nav className="flex flex-wrap justify-center space-x-4">
            <a href="#home" className="text-white no-underline text-lg">Home</a>
            <a href="#achievements" className="text-white no-underline text-lg">Achievements</a>
            <a href="#projects" className="text-white no-underline text-lg">Professional Overview</a>
            <a href="#contact" className="text-white no-underline text-lg">Contact</a>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
